import type { Entity } from '@backstage/catalog-model';

export const ANNOTATIONS = {
  SERVICE: 'datadoghq.com/service',
  SLO_ID: 'datadoghq.com/slo-id',
  DASHBOARD_ID: 'datadoghq.com/dashboard-id',
} as const;

export function isDatadogAvailable(entity: Entity): boolean {
  const annotations = entity.metadata.annotations;
  if (!annotations) return false;
  return Boolean(
    annotations[ANNOTATIONS.SERVICE] ||
      annotations[ANNOTATIONS.SLO_ID] ||
      annotations[ANNOTATIONS.DASHBOARD_ID],
  );
}

export function getServiceName(entity: Entity): string | undefined {
  return entity.metadata.annotations?.[ANNOTATIONS.SERVICE];
}

export function getSloIds(entity: Entity): string[] | undefined {
  const value = entity.metadata.annotations?.[ANNOTATIONS.SLO_ID];
  if (!value) return undefined;
  return value.split(',').map(id => id.trim()).filter(Boolean);
}

export function getDashboardIds(entity: Entity): string[] | undefined {
  const value = entity.metadata.annotations?.[ANNOTATIONS.DASHBOARD_ID];
  if (!value) return undefined;
  return value.split(',').map(id => id.trim()).filter(Boolean);
}
